import { gql } from '@apollo/client'

// QUERIES

export const FETCH_STRIPE_PRODUCTS = gql`
  query allStripeProducts($filter: ProductFilter) {
    allStripeProducts(filter: $filter) {
      stripeObject {
        active
        description
        name
        id
        metadata
        prices {
          id
          active
          chargeAmount {
            formattedAmount
          }
          type
          recurring {
            interval
            intervalCount
          }
        }
      }
      group
      status
    }
  }
`

export const FETCH_STRIPE_SUBSCRIPTION = gql`
  query StripeSubscription($id: ID!) {
    StripeSubscription(id: $id) {
      id
      canceledAt
      endedAt
      currentPeriodEnd
      currentPeriodStart
      items {
        quantity
        price {
          active
          chargeAmount {
            amount
            formattedAmount
          }
          recurring {
            interval
            intervalCount
          }
          type
          product {
            id
            name
            description
          }
        }
      }
    }
  }
`

// MUTATIONS

export const CREATE_STRIPE_SESSION = gql`
  mutation createStripeSession(
    $priceId: String!
    $cancelUrl: String!
    $successUrl: String!
    $accountId: ID!
    $serviceId: ID!
  ) {
    createStripeSession(
      priceId: $priceId
      cancelUrl: $cancelUrl
      successUrl: $successUrl
      accountId: $accountId
      serviceId: $serviceId
    ) {
      session {
        id
      }
      errors
    }
  }
`

export const CREATE_STRIPE_PORTAL_SESSION = gql`
  mutation createStripePortalSession($customerId: ID!, $returnUrl: String!) {
    createStripePortalSession(customerId: $customerId, returnUrl: $returnUrl) {
      session {
        url
      }
      errors
    }
  }
`
